initCarouselDrag();
initBlogSearch();

function initCarouselDrag() {
  const track = document.querySelector('[data-carousel-track]');
  if (!track) return;

  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let rafId = null;

  track.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX;
    startScrollLeft = track.scrollLeft;
    track.classList.add('is-dragging');
  });

  const onMouseMove = (e) => {
    if (!isDragging) return;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      track.scrollLeft = startScrollLeft - (e.pageX - startX);
    });
  };

  const endDrag = () => {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('is-dragging');
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  };

  track.addEventListener('mousemove', onMouseMove, { passive: true });
  track.addEventListener('mouseup', endDrag);
  track.addEventListener('mouseleave', endDrag);
}

function initBlogSearch() {
  const wrapper = document.querySelector('[data-predictive-search]');
  if (!wrapper) return;

  const input = wrapper.querySelector('[data-blog-search-input]');
  const results = wrapper.querySelector('[data-search-results]');
  const list = wrapper.querySelector('[data-search-list]');
  const template = wrapper.querySelector('[data-search-result-template]');
  const emptyMsg = wrapper.querySelector('[data-search-empty]');
  const overlay = document.querySelector('[data-search-overlay]');

  if (!input || !results || !list || !template) return;

  let debounceTimer = null;
  let abortController = null;

  const openSearch = () => {
    wrapper.classList.add('is-active');
    results.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.documentElement.classList.add('search-open');
    document.body.classList.add('search-open');
  };

  const closeSearch = () => {
    wrapper.classList.remove('is-active');
    results.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    document.documentElement.classList.remove('search-open');
    document.body.classList.remove('search-open');
  };

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = input.value.trim();
    if (query.length < 2) {
      closeSearch();
      return;
    }
    debounceTimer = setTimeout(() => fetchResults(query), 200);
  });

  const onKeyDown = (e) => {
    if (e.key !== 'Escape') return;
    closeSearch();
    input.blur();
  };

  const onDocClick = (e) => {
    if (wrapper.contains(e.target)) return;
    closeSearch();
    input.blur();
  };

  document.addEventListener('keydown', onKeyDown);
  document.addEventListener('click', onDocClick);

  const renderResults = (articles) => {
    list.replaceChildren();

    if (!articles.length) {
      if (emptyMsg) emptyMsg.hidden = false;
      openSearch();
      return;
    }

    if (emptyMsg) emptyMsg.hidden = true;

    const fragment = document.createDocumentFragment();

    for (const article of articles) {
      const clone = template.content.cloneNode(true);
      const link = clone.querySelector('[data-result-link]');
      const imgWrapper = clone.querySelector('[data-result-img-wrapper]');
      const img = clone.querySelector('[data-result-img]');
      const title = clone.querySelector('[data-result-title]');

      if (link) link.href = article.url;
      if (title) title.textContent = article.title ?? '';

      const imageUrl = article.featured_image?.url ?? null;
      if (img && imageUrl) {
        img.src = imageUrl;
        img.alt = article.featured_image?.alt ?? article.title ?? '';
      } else if (imgWrapper) {
        imgWrapper.remove();
      }

      fragment.appendChild(clone);
    }

    list.appendChild(fragment);
    openSearch();
  };

  const fetchResults = async (query) => {
    if (abortController) abortController.abort();
    abortController = new AbortController();
    const { signal } = abortController;

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=9`;
      const response = await fetch(url, { signal });
      if (!response.ok) return;
      const { resources } = await response.json();
      const articles = (resources?.results?.articles ?? [])
        .map(a => ({ ...a, _ts: new Date(a.published_at).getTime() }))
        .sort((a, b) => b._ts - a._ts);
      renderResults(articles);
    } catch (err) {
      if (err.name !== 'AbortError') closeSearch();
    }
  };
}
